import React from 'react';
import { useNavigate } from 'react-router-dom';

/**
 * Переиспользуемый Header компонент
 *
 * @param {Object} props
 * @param {string} props.title - Заголовок страницы
 * @param {boolean} props.showBackButton - Показывать кнопку назад
 * @param {function} props.onBackClick - Кастомный обработчик кнопки назад
 * @param {ReactNode} props.leftContent - Контент слева
 * @param {ReactNode} props.centerContent - Контент в центре (альтернатива title)
 * @param {ReactNode} props.rightContent - Контент справа
 * @param {string} props.className - Дополнительные CSS классы
 * @param {string} props.variant - Вариант стиля: 'default', 'transparent', 'colored'
 */
const Header = ({
  title = '',
  showBackButton = false,
  onBackClick,
  leftContent,
  centerContent,
  rightContent,
  className = '',
  variant = 'default',
  ...props
}) => {
  const navigate = useNavigate();

  const handleBackClick = () => {
    if (onBackClick) {
      onBackClick();
    } else {
      navigate(-1);
    }
  };

  const variants = {
    default: 'bg-white border-b border-gray-200',
    transparent: 'bg-transparent',
    colored: 'bg-[#A1F69E]',
  };

  const headerClasses = `
    flex items-center justify-between
    w-full h-16 px-4 py-2
    ${variants[variant] || variants.default}
    ${className}
  `
    .trim()
    .replace(/\s+/g, ' ');

  return (
    <header className={headerClasses} {...props}>
      {/* Левая часть */}
      <div className="flex items-center">
        {showBackButton && (
          <button
            onClick={handleBackClick}
          >
            <img src="/icons/Button-back.svg" className="w-[44px]" alt="" />
          </button>
        )}
        {leftContent}
      </div>

      {/* Центральная часть - заголовок или кастомный контент */}
      <div className="flex-1 flex justify-center items-center">
        {centerContent || (title && <h1 className="text-lg font-semibold text-gray-900 font-raleway">{title}</h1>)}
      </div>

      {/* Правая часть */}
      <div className="flex items-center">{rightContent}</div>
    </header>
  );
};

export default Header;
